import { useAuth } from "context/auth-context";
import styled from "@emotion/styled";


const StoreBadge = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;
  width: 15.75rem;   /* 157.5px */
  height: 4.708rem;  /* 47.08px */
  background: #111;
  color: #fff;
  border-radius: 1.6rem;
  text-decoration: none;
  padding: 0 1.2rem;
  border: 1px solid #ffffff;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.08);
  cursor: pointer;
  &:hover {
    border-color: #ffffff;
  }
  img {
    width: 2rem;
    height: 2rem;
  }
  span {
    display: flex;
    flex-direction: column;
    line-height: 1.1;
  }
  small {
    font-size: 0.9rem;
    opacity: 0.8;
  }
  strong {
    font-size: 1.4rem;
  }
`;


const StoreRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem; /* 40px */
  margin: 0 0 1.6rem 0;
`;


export const BrandedAppDonwLoadLink = () => {

    const { restaurantLoyaltySetting } = useAuth();

    const loyaltyContractSetting = restaurantLoyaltySetting?.loyaltyContractSetting;
    const enableBrandedAppDownload = !!loyaltyContractSetting?.enable_branded_app_download;
    const appStoreUrl = loyaltyContractSetting?.app_store_url;
    const googlePlayUrl = loyaltyContractSetting?.google_play_url;
    const showAppStoreBadge = enableBrandedAppDownload && !!appStoreUrl;
    const showGoogleBadge = enableBrandedAppDownload && !!googlePlayUrl;
    const showStoreBadges = showAppStoreBadge || showGoogleBadge;

    if (!showStoreBadges) return null;

    return (
        <StoreRow>
            {showAppStoreBadge && (
                <StoreBadge
                    type="button"
                    onClick={() => appStoreUrl && window.open(appStoreUrl, "_blank")}
                >
                    <img src={"/Apple.png"} alt="Apple" />
                    <span>
                        <small>Download on the</small>
                        <strong>App Store</strong>
                    </span>
                </StoreBadge>
            )}
            {showGoogleBadge && (
                <StoreBadge
                    type="button"
                    onClick={() => googlePlayUrl && window.open(googlePlayUrl, "_blank")}
                >
                    <img src={"/Google.png"} alt="Google Play" />
                    <span>
                        <small>GET IT ON</small>
                        <strong>Google Play</strong>
                    </span>
                </StoreBadge>
            )}
        </StoreRow>
    )
} 